import axios from 'axios';

export const searchForSite = (keyword) => {
  return new Promise((resolve, reject)=>{
    axios.get('/data.json').then((request) => {
      // return a single result from the dummy file for now
      var d = request.data.info;
      resolve([d]);
    });
  })
};




// WEBPACK FOOTER //
// ./src/data/search.js